class ShellCilindInternalPressCalculator {
    constructor() {
        /* MATERIAL */
        this.materialSpecification = "";
        this.nominalComposition = "";
        this.productForm = "";
        this.alloyDesignation = "";
        this.classConditionTemper = "";
        this.pNo = "";
        this.groupNo = "";

        /* PROPRIEDADES MECÂNICAS */
        this.minTensileStrength = 0;
        this.minYieldStrength = 0;
        this.viiiApplicAndMaxTemLimit = 0;

        /* DADOS DE PROJETO */
        this.designTemperature = 0;
        this.rangeDesignTemperature = 0;

        this.insideDiameter = null;
        this.shellLength = null;
        this.liquidColumn = null;
        this.density = null;

        this.designPressureTop = 0;
        this.designPressure = 0;

        this.admissibleStressDesignTemp = 0;
        this.admissibleStressRoomTemp = 0;

        this.insideRadius = 0;
        this.insideRadiusCorroded = 0;

        this.corrosionAllowance = 0;

        this.nominalThicknessMinusCorrosionAloowance = 0;

        this.weldedJointEfficiency = "";
        this.nominalThickness = "";

        /* RESULTADOS */
        this.validNominalThickness = true;

        this.designThickness = 0;
        this.workingMaximumAllowablePressure = 0;
        this.hidrostaticTestPressure = 0;
        this.pneumaticTestPressure = 0;

        // Range design temperature celsius
        this.rangeDesignTemperatureCelsius = {
            '37,78': '0',
            '65,56': '0',
            '93,33': '0',
            '121,11': '0',
            '148,89': '0',
            '204,44': '0',
            '260,00': '0',
            '315,56': '0',
            '343,33': '0',
            '371,11': '0',
            '398,89': '0',
            '426,67': '0',
            '454,44': '0',
            '482,22': '0',
            '510,00': '0',
            '537,78': '0',
            '565,56': '0',
            '593,33': '0',
            '621,11': '0',
            '648,89': '0',
            '676,67': '0',
            '704,44': '0',
            '732,22': '0',
            '760,00': '0',
            '787,78': '0',
            '815,56': '0',
            '843,33': '0',
            '871,11': '0',
            '898,89': '0',
        };
    }   
}

export default ShellCilindInternalPressCalculator;